import { createReducer } from '@reduxjs/toolkit';
import { showHideLoader } from 'actionCreators/loader';
import { responseFailed } from 'actionCreators/error';
import { setOfferDocument, updateOfferDocumentCount } from 'actionCreators/offer';
import {
  setAccountCount,
  accountDetailsByIdSuccess,
  accountListSuccessResponse
} from 'actionCreators/account';

const loaderReducer = createReducer(
  { isLoading: false, totalOfferDocuments: 0, totalAccounts: 0, currentCount: 0 },
  (builder) => {
    builder.addCase(showHideLoader, (state, action) => {
      /**
       * @todo refactor so payload is just true/false (no { isLoading })
       */
      state.isLoading = action.payload.isLoading;
    });

    builder.addCase(responseFailed, (state) => {
      state.isLoading = false;
    });

    builder.addCase(setOfferDocument, (state, action) => {
      state.totalOfferDocuments = action.payload;
    });

    builder.addCase(updateOfferDocumentCount, (state) => {
      const currentDocument = state.currentDocument;
      return {
        ...state,
        currentDocument: currentDocument + 1,
        isLoading: state.totalOfferDocuments - 1 === state.currentDocument
      };
    });

    builder.addCase(setAccountCount, (state, action) => {
      state.totalAccounts = action.payload;
    });

    builder.addCase(accountDetailsByIdSuccess, (state) => {
      return {
        ...state,
        currentCount: state.currentCount + 1,
        isLoading: state.totalAccounts - 1 !== state.currentCount
      };
    });

    builder.addCase(accountListSuccessResponse, (state) => {
      state.currentCount = 0;
    });
  }
);

export { loaderReducer };
